import React from 'react';
import { formatDate } from '../../utils/helper';

function DelayReason(props) {
  const {
    delayReason,
    revisedEta,
    view,
    dataLocale: { DELIVERY_DELAY, SORRY_DELAY_DUE_TO, WILL_DELIVER_PRODUCT_BY } = {},
  } = props;
  return (
    <div
      className={`delayed-reason ${
        view === 'desktop' ? 'margin-l20 margin-r20 padding-15 color-33' : ' pd-12 color_grey_black'
      }`}
      data-testid="delayedReason"
    >
      <div className="fsp14 fs14 fw700">{DELIVERY_DELAY}</div>
      <div className="mr-t5 fsp12 margin-t5">
        {SORRY_DELAY_DUE_TO} {delayReason}. {WILL_DELIVER_PRODUCT_BY}{' '}
        {formatDate(revisedEta, 'EEE, D MMM')}
      </div>
    </div>
  );
}

export default DelayReason;
